export const DEFAULT_TOP_FIX_INFO_VALUE = "-";

export const TOP_FIX_INFO_DEFAULT = {
  draftArticleId: {
    title: "Press ID",
    minWidth: "13rem",
    maxWidth: "none",
    width: "fit-content",
  },
  pressDate: {
    title: "Press Date",
    minWidth: "none",
    maxWidth: "22rem",
    width: "fit-content",
  },
  companyName: { title: "Company", minWidth: "7.2rem", maxWidth: "none" },
  classificationAiName: {
    title: "AI Classification",
    minWidth: "12rem",
    maxWidth: "24rem",
  },
  classificationManualName: {
    title: "Manual Classification",
    minWidth: "12rem",
    maxWidth: "24rem",
  },
  mcEditorName: {
    title: "MC Editor",
    minWidth: "6.4rem",
    maxWidth: "20rem",
  },
  ftEditorName: {
    title: "FT 1 Editor",
    minWidth: "6.4rem",
    maxWidth: "20rem",
  },
  ftEditor2Name: {
    title: "FT 2 Editor",
    minWidth: "6.4rem",
    maxWidth: "20rem",
  },
  pbEditorName: {
    title: "Publisher",
    minWidth: "6.4rem",
    maxWidth: "20rem",
  },
};

export const TOP_FIX_INFO_PUBLICATION = {
  publicationId: {
    title: "Publication ID",
    minWidth: "none",
    maxWidth: "12rem",
  },
  doi: {
    title: "DOI",
    minWidth: "none",
    maxWidth: "12rem",
  },
  publicationDate: {
    title: "Publication Date",
    minWidth: "none",
    maxWidth: "12rem",
  },
  journalName: {
    title: "Journal Name (eISSN)",
    minWidth: "16rem",
    maxWidth: "auto",
  },
  affiliation: {
    title: "Affiliation",
    minWidth: "16rem",
    maxWidth: "auto",
  },
  topicType: {
    title: "Topic Type",
    minWidth: "16rem",
    maxWidth: "24rem",
  },
  mcEditorName: {
    title: "MC Editor",
    minWidth: "6.4rem",
    maxWidth: "auto",
  },
  ftEditor2Name: {
    title: "FT 2 Editor",
    minWidth: "6.4rem",
    maxWidth: "auto",
  },
};

export const TOP_FIX_INFO_REGULATORY = {
  id: {
    title: "ID",
    minWidth: "9.6rem",
    maxWidth: "none",
  },
  labelId: {
    title: "Label ID",
    minWidth: "12rem",
    maxWidth: "none",
  },
  regulatoryAgency: {
    title: "Regulatory Agency",
    minWidth: "12rem",
    maxWidth: "none",
  },
  labelDate: {
    title: "Label Date",
    minWidth: "12rem",
    maxWidth: "none",
  },
  companyName: {
    title: "Company",
    minWidth: "16rem",
    maxWidth: "none",
  },
  labelName: {
    title: "Label Name",
    minWidth: "16rem",
    maxWidth: "none",
  },
  classification: {
    title: "Classification",
    minWidth: "16rem",
    maxWidth: "none",
  },
  ftEditorName: {
    title: "FT Editor",
    minWidth: "6.4rem",
    maxWidth: "none",
  },
};

export const TOP_FIX_INFO_CTG = {
  id: {
    title: "ID",
    minWidth: "auto",
    maxWidth: "9.6rem",
  },
  registryId: {
    title: "Registry ID",
    minWidth: "auto",
    maxWidth: "16rem",
  },
  registryAgency: {
    title: "Registry Agency",
    minWidth: "auto",
    maxWidth: "12rem",
  },
  registryDate: {
    title: "Registry Date",
    minWidth: "auto",
    maxWidth: "12rem",
  },
  organizationName: {
    title: "Organization Name",
    minWidth: "16rem",
    maxWidth: "40rem",
  },
  sponsorName: {
    title: "Sponsor Name",
    minWidth: "16rem",
    maxWidth: "40rem",
  },
  collaboratorName: {
    title: "Collaborator Name",
    minWidth: "16rem",
    maxWidth: "auto",
  },
};
